<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('MWCC000002') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select :value="searchParams.plantCd" :placeholder="getMessage_('MWCC000002')" @change="change">
				<el-option v-for="(plant, index) in plants" :label="plant.commCdName" :value="plant.commCd" :key="index"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GridFreeForm/store/helpers';
export default {
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		change(value) {
			return this.setSearchParam_({ key: 'plantCd', value: value });
		}
	}
};
</script>

<style></style>
